import { render, staticRenderFns } from "./SectionContact.vue?vue&type=template&id=0b66bc27&scoped=true"
import script from "./SectionContact.vue?vue&type=script&lang=ts"
export * from "./SectionContact.vue?vue&type=script&lang=ts"
import style0 from "./SectionContact.vue?vue&type=style&index=0&id=0b66bc27&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b66bc27",
  null
  
)

export default component.exports